import { ASSIGN_PORTAL_GLOSSARY, CREATE_GLOSSARY, DELETE_GLOSSARY, LIST_GLOSSARY, PORTALS_DROP_DOWN, UPLOAD_CSV_FILE } from "./types";

export const uploadCsvFile = (file, onSuccess, onError) => {
    return {
        type: UPLOAD_CSV_FILE,
        file,
        onSuccess,
        onError,
    };
};

export const craeteGlossaryAction = (data, onSuccess, onError) => {
    return {
        type: CREATE_GLOSSARY,
        data,
        onSuccess,
        onError,
    };
};

export const listGlossaryAction = (data, onSuccess, onError) => {
    return {
        type: LIST_GLOSSARY,
        data,
        onSuccess,
        onError,
    };
};

export const deleteGlossaryAction = (data, onSuccess, onError) => {
    return {
        type: DELETE_GLOSSARY,
        data,
        onSuccess,
        onError,
    };
};

export const assignGlossaryPortalAction = (data, onSuccess, onError) => {
    return {
        type: ASSIGN_PORTAL_GLOSSARY,
        data,
        onSuccess,
        onError,
    };
};

export const portalDropDownAction = (data, onSuccess, onError) => {
    return {
        type: PORTALS_DROP_DOWN,
        data,
        onSuccess,
        onError,
    };
};